import { styled } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';

export const SendoutNoteContainer = styled('div')(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.customColors.borderColor}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
}));

export const StyledTypography = styled(Typography)({
  whiteSpace: 'pre-wrap'
});
